export const imagesConfig = [
  {
    title: '1 Bild',
    iconName: 'image',
    value: 1,
  },
  {
    title: '2 Bilder',
    iconName: 'images',
    value: 2,
  },
  {
    title: '3 Bilder',
    iconName: 'images',
    value: 3,
  },
  {
    title: '4 Bilder',
    iconName: 'images',
    value: 4,
  },
];

export const ablenkerConfig = [
  {
    title: 'Semantische Ablenker',
    value: 'related',
  },
  {
    title: 'Unrelatierte Ablenker',
    value: 'unrelated',
  },
  {
    title: 'Aus Set',
    value: 'wordset',
  },
];
